import type { BackendRouteDefinition } from '../types';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S2-WB2
// (PRA-788). Now served by `api-core-node` at
// `GET /api/firms/google-workspace/credentials`. See
// `generateGoogleAuthUrl.ts` for the retirement-deferred callable note.

export const getGoogleCredentialsRoute = {
  transport: 'api',
  method: 'GET',
  path: '/firms/google-workspace/credentials',
} as const satisfies BackendRouteDefinition;
